import React from "react";
import VideoPanel from "../../../react-components/page-framework/video-panel";
import { SVG } from "../../../component-configuration/svgs";
import { VideoModal } from "./video-modal";
import { store } from "../../../redux";
import { setPlayingFullScreen } from "../../../redux/actions";
import thumbnail1 from "../images/howto-join-create-profile-thumbnail.jpg";
import thumbnail2 from "../images/howto-claim-profile-thumbnail.jpg";
import thumbnail3 from "../images/howto-pitch-planet-story-thumbnail.jpg";
import thumbnail4 from "../images/howto-marketplace-products-thumbnail.jpg";
import thumbnail5 from "../images/howto-promoted-social-thumbnail.jpg";
import thumbnail6 from "../images/howto-shows-interviews-thumbnail.jpg";

const VIDEOS = [
  {
    youtubeId: "VyscfFjO6Eg",
    title: "JOIN & CREATE",
    subtitle: "YOUR PROFILE PAGE",
    preview: thumbnail1,
  },
  {
    youtubeId: "tjM64QpX-mA",
    title: "HOW TO",
    subtitle: "CLAIM YOUR PROFILE",
    preview: thumbnail2,
  },
  {
    youtubeId: "4oH-XCeZxPI",
    title: "TELL YOUR STORY",
    subtitle: "ON PITCH PLANET",
    preview: thumbnail3,
  },
  {
    youtubeId: "nGAqmTndKY4",
    title: "SHOWCASE YOUR PRODUCTS",
    subtitle: "ON MARKETPLACE",
    preview: thumbnail4,
  },
  {
    youtubeId: "A0xvXJDoTgk",
    title: "BE PROMOTED",
    subtitle: "ON RADIVISION & SOCIAL MEDIA",
    preview: thumbnail5,
  },
  {
    youtubeId: "THXGScnjZ9o",
    title: "BE A STAR",
    subtitle: "IN OUR SHOWS & INTERVIEWS",
    preview: thumbnail6,
  },
];
const HowTo = () => {
  return (
    <section className="mb-5 px-5">
      <h3>How to Videos</h3>
      <div className="videos-grid">
        {VIDEOS.map(({ youtubeId, title, subtitle, preview, comingSoon }, index: number) => {
          // const image = `${preview}`;
          return (
            <div
              className={`video-item`}
              key={`youtube-${youtubeId}-${index}`}
              onClick={() => {
                {
                  // !comingSoon &&
                  store.dispatch(setPlayingFullScreen({ videoId: youtubeId, status: true }));
                }
              }}
            >
              <div className="video-preview" style={{ backgroundImage: `url(${preview})` }} />
              <div className={`title`}>
                <h3>{title}</h3>
                <h4>{subtitle}</h4>
                <div className="play-icon">{SVG.play}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HowTo;
